"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSpacesFromInput = (inp) => {
    return inp.replace(/\s*/g, '');
};
exports.convertSpecialChar = (inp) => {
    return `${inp
        .replace(/\(/g, '\\(')
        .replace(/\)/g, '\\)')
        .replace(/\\/g, '\\/')
        .replace(/\+/g, '\\+')
        .replace(/\-/g, '\\-')
        .replace(/\*/g, '\\*')}`;
};
